type MessageType = 'danger' | 'warning' | 'success' | 'info'

export default class Message {
  title: string
  text?: any
  type?: MessageType
  time: Date
  secondsVisible: number

  constructor(title: string, text?: any, type = 'success' as MessageType, secondsVisible = -1) {
    this.title = title
    this.time = new Date()
    this.text = text
    this.type = type
    this.secondsVisible = secondsVisible
  }

  equals(message: Message) {
    return JSON.stringify(this) === JSON.stringify(message)
  }
}
